import { useMutation } from '@tanstack/react-query'
import axiosClient from '../axios'

export interface SubmitBugReportPayload {
  description: string
  /** Light context captured at submit time (caseId, view, url, userAgent…). */
  context?: Record<string, unknown>
}

/** Report a bug from inside the app — emails the product owner directly. */
export function useSubmitBugReport() {
  return useMutation({
    mutationFn: async (payload: SubmitBugReportPayload) => {
      const { data } = await axiosClient.post('/bug-reports', payload)
      return data
    },
  })
}
